
import { supabase } from "@/integrations/supabase/client";
import { DetectedLocation } from '../mappings/LocationMapping';
import { applyPriceFilter } from '../filters/PriceFilter';
import { applyFacilitiesFilter } from '../filters/FacilitiesFilter';
import { applyTravelDistanceFilter } from '../filters/TravelDistanceFilter';
import { verifyAndFilterResults } from '../utils/ResultsVerification';

export const handleCoastaBravaSearch = async (
  detectedLocation: DetectedLocation,
  priceConstraints: any,
  detectedFacilities: any,
  travelConstraints: any,
  query: string
) => {
  console.log('🏖️ === COSTA BRAVA REGION SEARCH - USING BROADER APPROACH ===');
  
  let dbQuery = supabase
    .from('Complete feed')
    .select('*')
    .not('imageURL', 'is', null)
    .not('name', 'is', null)
    .eq('country', 'Spanje')
    .or('region.ilike.%Costa Brava%,city.ilike.%Costa Brava%,description.ilike.%Costa Brava%');

  // Apply additional filters
  if (priceConstraints) {
    console.log('💰 === APPLYING PRICE FILTERS TO COSTA BRAVA ===');
    console.log('Before price filter - Costa Brava query built');
    dbQuery = applyPriceFilter(dbQuery, priceConstraints);
    console.log('After price filter - Costa Brava query updated');
  }

  if (detectedFacilities) {
    console.log('🏨 === APPLYING FACILITIES FILTERS ===');
    dbQuery = applyFacilitiesFilter(dbQuery, detectedFacilities);
  }

  if (travelConstraints) {
    console.log('🛫 === APPLYING TRAVEL DISTANCE FILTERS ===');
    dbQuery = applyTravelDistanceFilter(dbQuery, travelConstraints);
  }

  // Execute query
  const { data, error } = await dbQuery.limit(100);
  
  if (error) {
    console.error('❌ Costa Brava search error:', error);
    throw error;
  }
  
  console.log(`🏖️ Costa Brava search found ${data?.length || 0} results`);
  return verifyAndFilterResults(data || [], detectedLocation, priceConstraints, detectedFacilities, query);
};
